/* Tucker pages on Shopify: the prototype's films, the 51, car panels and the timeline, adapted from
   website/prototype/assets/js/site.js. Horizon owns the header, footer, cart and product pages; this file
   only fills the Tucker sections (everything inside a .tk wrapper).

   Data:   window.TUCKER (tucker-data.js), window.TUCKER_STORY, window.TUCKER_CAR (tucker-car-art.js),
           window.TUCKER_MARKS (tucker-brand.js).
   Photos: Shopify Files. window.TK_FILES is the files folder URL, set in layout/theme.liquid. */
(function () {
  'use strict';

  var T = window.TUCKER || { cars: [], videos: [], products: [] };
  var FILES = window.TK_FILES || '';
  var EMAIL = 'info@tuckercorporation.com';
  var URL = { cars: '/pages/the-cars', watch: '/pages/watch', story: '/pages/our-story', archive: '/pages/archive', shop: '/collections/all' };

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function yt(id) { return 'https://www.youtube.com/watch?v=' + id; }
  // YouTube's stills: maxresdefault is 1280x720 (the big card), sddefault 640x480 (the rest; cropped to 16:9 by
  // the card). hqdefault, at 480x360, looked soft on the big card (Sean, 10-17).
  function thumb(id, big) { return 'https://i.ytimg.com/vi/' + id + (big ? '/maxresdefault.jpg' : '/sddefault.jpg'); }
  function file(path) { return FILES + String(path).split('/').pop(); }
  function byId(list, id) { for (var i = 0; i < list.length; i++) if (list[i].id === id) return list[i]; return null; }
  function car(serial) { for (var i = 0; i < T.cars.length; i++) if (T.cars[i].serial === serial) return T.cars[i]; return null; }
  function video(id) { return byId(T.videos, id); }
  // full films only: Shorts appear in a car's panel and nowhere else (Sean, 10-30)
  function fullFilms() { return T.videos.filter(function (v) { return !v.short; }); }
  function onCarsPage() { return !!$('#cars'); }

  var ICON = {
    close: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M18.3 5.7 12 12l6.3 6.3-1.4 1.4L10.6 13.4 4.3 19.7 2.9 18.3 9.2 12 2.9 5.7l1.4-1.4 6.3 6.3 6.3-6.3 1.4 1.4Z"/></svg>',
    play: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 4v16l14-8L6 4Z"/></svg>'
  };

  function carArt(cls) {
    var C = window.TUCKER_CAR;
    if (!C) return '';
    return '<svg class="car-art ' + (cls || '') + '" viewBox="' + C.viewBox + '" aria-hidden="true" focusable="false">' + C.body + '</svg>';
  }
  function mark(key, cls) {
    var m = (window.TUCKER_MARKS || {})[key];
    return m ? '<svg class="' + (cls || '') + '" viewBox="' + m.viewBox + '" aria-hidden="true" focusable="false"><path d="' + m.d + '"/></svg>' : '';
  }

  /* ---------------------------------------------------------------- modal (car, story, film) */

  function layer() {
    var root = $('#tk-layer');
    if (root) return root;
    document.body.insertAdjacentHTML('beforeend',
      '<div class="tk" id="tk-layer"><div class="modal" id="tk-modal" role="dialog" aria-modal="true" aria-hidden="true"><div class="panel" id="tk-panel"></div></div></div>');
    root = $('#tk-layer');
    $('#tk-modal').addEventListener('click', function (e) { if (e.target === this) closeModal(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });
    return root;
  }
  var lastFocus = null;
  function openModal(html, cls) {
    layer();
    lastFocus = document.activeElement;
    var panel = $('#tk-panel');
    panel.className = 'panel' + (cls ? ' ' + cls : '');
    panel.innerHTML = html;
    $('#tk-modal').classList.add('open');
    $('#tk-modal').setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    var x = $('[data-x]', panel);
    if (x) { x.addEventListener('click', closeModal); x.focus(); }
  }
  function closeModal() {
    var m = $('#tk-modal');
    if (!m || !m.classList.contains('open')) return;
    m.classList.remove('open');
    m.setAttribute('aria-hidden', 'true');
    $('#tk-panel').innerHTML = '';
    document.documentElement.style.overflow = '';
    if (/^#\d{4}$/.test(location.hash)) history.replaceState(null, '', location.pathname + location.search);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function playFilm(id) {
    var v = video(id) || { title: '' };
    openModal('<button class="icon-btn close" data-x aria-label="Close">' + ICON.close + '</button>' +
      '<div style="grid-column:1/-1;background:#000"><iframe class="film-embed' + (v.short ? ' short' : '') + '" src="https://www.youtube-nocookie.com/embed/' + id +
      '?autoplay=1&rel=0" title="' + esc(v.title) + '" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen></iframe></div>');
  }

  /* ---------------------------------------------------------------- films */

  function filmCard(v, big) {
    var shop = (T.products || []).filter(function (p) { return (p.films || []).indexOf(v.id) >= 0; })[0];
    return '<div class="film' + (big ? ' big' : '') + '">' +
      '<a class="thumb" href="' + yt(v.id) + '" target="_blank" rel="noopener" data-film="' + v.id + '" aria-label="Play: ' + esc(v.title) + '">' +
        '<img src="' + thumb(v.id, big) + '" alt="" loading="lazy"><span class="playmark">' + ICON.play + '</span></a>' +
      '<div><div class="t">' + esc(v.title) + '</div>' +
      '<div class="v">' + new Date(v.date + 'T12:00:00').toLocaleDateString('en-US', { month: 'short', year: 'numeric' }) +
        (v.cars.length && v.cars[0] !== 'TEST' ? ' · ' + v.cars.map(function (c) { return '<a href="' + URL.cars + '#' + c + '">#' + c + '</a>'; }).join(', ') : '') + '</div>' +
      (shop ? '<a class="shop-link" href="/products/' + shop.id + '">Shop ' + (/^the /i.test(shop.name) ? '' : 'the ') + esc(shop.name) + ' →</a>' : '') +
      '</div></div>';
  }
  function byViews(a, b) { return (b.views || 0) - (a.views || 0); }
  function byDate(a, b) { return a.date < b.date ? 1 : -1; }

  /* ---------------------------------------------------------------- cars */

  // the two 'tell us' buttons near the top of a car's panel (Sean, 10-18: the lines at the bottom were missed)
  function askButtons(c) {
    function mail(what) { return 'mailto:' + EMAIL + '?subject=' + encodeURIComponent('Tucker #' + c.serial + ': ' + what); }
    var own = c.status === 'family' ? null
      : c.status === 'lost' ? ['Know where it is? Tell us', 'what happened to it']
      : (c.status === 'museum' || c.owner) ? ['Update this car\u2019s details', 'update']
      : ['Own this car? Tell us', 'owner update'];
    return '<div class="ask-btns">' +
      (own ? '<a class="btn small" href="' + mail(own[1]) + '">' + own[0] + '</a>' : '') +
      '<a class="btn ghost small" href="' + mail('photo or story') + '">Send a photo or story</a></div>';
  }
  function statusText(c) {
    if (c.status === 'family') return 'Survives · owned by Rob Ida and Sean and Mike Tucker';
    if (c.owner) return 'Survives · owned by ' + c.owner;
    if (c.status === 'lost') return 'Lost';
    return c.status === 'museum' ? 'Survives · on public display' : 'Survives · private collection';
  }
  function whereText(c) {
    if (c.status === 'family') return 'Rob Ida and the Tuckers';
    if (c.owner) return c.owner;
    if (c.status === 'museum') return c.museum;
    return c.status === 'lost' ? (c.museum ? 'Lost · part of frame at the AACA' : 'Lost') : 'Private collection';
  }
  function completedText(c) {
    for (var i = 0; i < c.build.length; i++) if (c.build[i][0] === 'Completed' || c.build[i][0] === 'Unveiled') return c.build[i][1];
    return '';
  }
  function carTile(c) {
    var when = completedText(c);
    return '<button class="car-tile" type="button" data-car="' + c.serial + '" data-status="' + c.status + '" style="--c:' + c.swatch + '" aria-label="Tucker ' + c.serial + ', ' + esc(statusText(c)) + '">' +
      '<span class="serial"><small>No.</small>' + c.serial + '</span>' +
      (c.status === 'family' ? '<span class="tag">Ida &amp; Tucker</span>' : '') +
      (c.status === 'museum' ? '<span class="dot" title="On public display"></span>' : '') +
      (c.films.length ? '<span class="play" title="We made a film about this car">' + ICON.play + '</span>' : '') +
      '<span class="where">' + esc(whereText(c)) + '</span>' +
      (when ? '<span class="when">' + esc(when) + '</span>' : '') +
      carArt('sil') + '</button>';
  }

  function openCar(serial) {
    var c = car(serial);
    if (!c) return;
    function filmLink(v) { return '<div><a href="' + yt(v.id) + '" target="_blank" rel="noopener" data-film="' + v.id + '" style="color:var(--red);font-weight:600">▶ ' + esc(v.title) + '</a></div>'; }
    var vids = c.films.map(video).filter(Boolean);
    var films = vids.filter(function (v) { return !v.short; }).map(filmLink).join('');
    var shorts = vids.filter(function (v) { return v.short; }).sort(byViews).map(filmLink).join('');
    var pics = c.photos || [];
    var gallery = pics.length ?
      '<img class="gallery-main" src="' + file(pics[0]) + '" alt="Tucker ' + c.serial + '">' +
      (pics.length > 1 ? '<div class="gallery-thumbs">' + pics.map(function (f, i) {
        return '<button type="button" data-pic="' + f + '" aria-current="' + (i === 0) + '" aria-label="Photo ' + (i + 1) + '"><img src="' + file(f) + '" alt=""></button>';
      }).join('') + '</div>' : '') : '';
    var build = c.build.map(function (b) { return '<dt>' + esc(b[0]) + '</dt><dd>' + esc(b[1]) + '</dd>'; }).join('');
    openModal(
      '<button class="icon-btn close" data-x aria-label="Close">' + ICON.close + '</button>' +
      '<div>' + gallery +
      '<div class="head" style="--c:' + c.swatch + '"><div><div class="serial">' + c.serial + '</div><div class="lbl">' + esc(statusText(c)) + '</div></div>' + carArt() + '</div>' +
      '<div class="facts">' +
        (c.teaser ? '<p class="teaser">' + esc(c.teaser) + '</p>' : '') +
        askButtons(c) +
        (build ? '<div><h4>As built</h4><dl>' + build + '</dl></div>' : '') +
        '<div><h4>Today</h4><dl>' +
          '<dt>Status</dt><dd>' + esc(statusText(c)) + '</dd>' +
          (c.museum ? '<dt>See it at</dt><dd>' + esc(c.museum) + '<br><span style="opacity:.7">' + esc(c.place) + '</span></dd>' : '') +
        '</dl></div>' +
        (films ? '<div><h4>Our films about this car</h4>' + films + '</div>' : '') +
        (shorts ? '<div><h4>Shorts</h4>' + shorts + '</div>' : '') +
      '</div></div>', 'car-panel');
    var panel = $('#tk-panel');
    $$('.gallery-thumbs button', panel).forEach(function (b) {
      b.addEventListener('click', function () {
        $('.gallery-main', panel).src = file(b.getAttribute('data-pic'));
        $$('.gallery-thumbs button', panel).forEach(function (x) { x.setAttribute('aria-current', x === b); });
      });
    });
    history.replaceState(null, '', '#' + c.serial);
  }

  /* ---------------------------------------------------------------- page parts */

  function homeParts() {
    var big = $('#film-big'), list = $('#film-list');
    if (big && T.videos.length) {
      var top = fullFilms().sort(byViews)[0];
      big.innerHTML = filmCard(top, true);
      if (list) list.innerHTML = fullFilms().sort(byDate).filter(function (v) { return v.id !== top.id; }).slice(0, 4).map(function (v) { return filmCard(v); }).join('');
    }
    var fleet = $('#fleet');
    if (fleet) fleet.innerHTML = T.cars.filter(function (c) { return !c.continuation; }).map(function (c) {
      return '<a href="' + URL.cars + '#' + c.serial + '" data-status="' + c.status + '" style="--c:' + c.swatch + '" title="Tucker ' + c.serial + ' · ' + esc(c.color || '') + '">' + carArt() + '</a>';
    }).join('');
    var s = T.stats || {};
    [['#stat-built', s.built], ['#stat-survive', s.survive], ['#stat-display', s.onDisplay]].forEach(function (p) { var el = $(p[0]); if (el && p[1]) el.textContent = p[1]; });
    var vid = $('.tk .tk-hero video');
    if (vid && window.matchMedia('(prefers-reduced-motion: reduce)').matches) { vid.removeAttribute('autoplay'); vid.pause(); }
  }

  function carsPage() {
    if (!onCarsPage()) return;
    var filter = 'all', color = null, colors = [];
    var the51 = T.cars.filter(function (c) { return !c.continuation; });
    the51.forEach(function (c) { if (c.color && colors.indexOf(c.color) < 0) colors.push(c.color); });
    function count(f) { return the51.filter(function (c) { return f === 'all' || c.status === f; }).length; }
    function draw() {
      var groups = [['all', 'All'], ['museum', 'On public display'], ['private', 'Private collections'], ['lost', 'Lost']];
      $('#car-chips').innerHTML = groups.map(function (g) {
        return '<button class="chip" type="button" aria-pressed="' + (filter === g[0]) + '" data-f="' + g[0] + '">' + g[1] + '<span class="n">' + count(g[0]) + '</span></button>';
      }).join('');
      $('#swatches').innerHTML = colors.map(function (k) {
        var sw = T.cars.filter(function (c) { return c.color === k; })[0].swatch;
        return '<button class="swatch-btn" type="button" aria-pressed="' + (color === k) + '" data-color="' + esc(k) + '"><i style="background:' + sw + '"></i>' + esc(k) + '</button>';
      }).join('');
      var list = the51.filter(function (c) { return (filter === 'all' || c.status === filter) && (!color || c.color === color); });
      $('#cars').innerHTML = list.map(carTile).join('') || '<p style="color:var(--muted-on-dark)">No cars match.</p>';
      $$('#car-chips .chip').forEach(function (b) { b.addEventListener('click', function () { filter = b.getAttribute('data-f'); draw(); }); });
      $$('#swatches .swatch-btn').forEach(function (b) { b.addEventListener('click', function () { var k = b.getAttribute('data-color'); color = color === k ? null : k; draw(); }); });
    }
    draw();
    var cont = $('#continuation');
    if (cont) cont.innerHTML = T.cars.filter(function (c) { return c.continuation; }).map(carTile).join('');
    var seen = {};
    T.cars.forEach(function (c) {
      if (!c.museum) return;
      var name = c.museum.replace(/ \(.*\)$/, '');
      (seen[name] = seen[name] || { place: c.place, cars: [] }).cars.push([c.serial, c.status === 'lost' ? ' (part of the frame)' : '']);
    });
    var mu = $('#museums');
    if (mu) mu.innerHTML = Object.keys(seen).sort(function (a, b) { return seen[a].place.localeCompare(seen[b].place); }).map(function (m) {
      return '<li><b>' + esc(m) + '</b><br><span style="opacity:.7">' + esc(seen[m].place) + '</span><br>' +
        seen[m].cars.map(function (s) { return '<a href="#' + s[0] + '" data-car="' + s[0] + '">#' + s[0] + '</a>' + s[1]; }).join(', ') + '</li>';
    }).join('');
    nearMe();
    if (/^#\d{4}$/.test(location.hash)) openCar(location.hash.slice(1));
  }

  // Find a Tucker near you (Mike's idea, live Oct 18 2026): the visitor's place -> the museums with a Tucker, closest first.
  // Places are looked up on OpenStreetMap (Nominatim; Photon if that fails), only when the visitor asks, never saved.
  function nearMe() {
    var form = $('#near-form');
    if (!form || !T.museums) return;
    var input = $('#near-q'), list = $('#near-list'), status = $('#near-status'), more = $('#near-more'), note = $('#near-note');
    var MILE_COUNTRIES = ['us', 'gb', 'lr', 'mm'], last = null, busy = false;

    function km(a, b, c, d) {
      var r = Math.PI / 180, x = Math.sin((c - a) * r / 2), y = Math.sin((d - b) * r / 2);
      var h = x * x + Math.cos(a * r) * Math.cos(c * r) * y * y;
      return 12742 * Math.asin(Math.min(1, Math.sqrt(h)));
    }
    function fmt(kmv) {
      var v = last.miles ? kmv * 0.621371 : kmv, unit = last.miles ? ' miles' : ' km';
      if (v < 1) return last.miles ? 'under a mile' : 'under 1 km';
      return Math.round(v).toLocaleString('en-US') + unit;
    }
    function band(kmv) {
      var mi = kmv * 0.621371;
      return mi <= 100 ? ['close', 'Close by'] : mi <= 300 ? ['day', 'A day trip'] : ['trip', 'Plan a trip'];
    }
    function draw(all) {
      var rows = all ? last.rows : last.rows.slice(0, 5), first = last.rows[0];
      status.textContent = first.d * 0.621371 > 300
        ? 'The nearest Tucker to ' + last.label + ' is ' + fmt(first.d) + ' away.'
        : 'Tuckers on display closest to ' + last.label + ':';
      list.innerHTML = rows.map(function (r) {
        var b = band(r.d), m = r.m;
        return '<li><div><div class="near-name">' + esc(m.name) + '</div><div class="near-where">' + esc(m.place) + '</div></div>' +
          '<div class="near-dist">' + fmt(r.d) + '<br><span class="near-band ' + b[0] + '">' + b[1] + '</span></div>' +
          '<div class="near-cars">' + m.cars.map(function (s) {
            return '<a href="#' + s + '" data-car="' + s + '">#' + s + '</a>' +
              ((m.off || []).indexOf(s) > -1 ? ' <strong class="near-off">Not on display</strong>' : '');
          }).join(', ') + '</div></li>';
      }).join('');
      more.hidden = all || last.rows.length <= 5;
      more.textContent = 'See all ' + last.rows.length + ' museums';
      note.hidden = false;
    }
    function show(lat, lon, label, cc) {
      var miles = cc ? MILE_COUNTRIES.indexOf(cc) > -1 : /-(US|GB)$/i.test(navigator.language || 'en-US');
      last = { label: label, miles: miles, rows: T.museums.map(function (m) { return { m: m, d: km(lat, lon, m.lat, m.lon) }; })
        .sort(function (a, b) { return a.d - b.d; }) };
      draw(false);
    }
    function clear() {   // a failed search must not leave the last place's results looking like the answer
      last = null;
      list.innerHTML = '<li class="near-empty" style="display:block">Your nearest Tuckers will show here.</li>';
      more.hidden = true;
      note.hidden = true;
    }
    function photon(q) {
      return fetch('https://photon.komoot.io/api/?limit=1&lang=en&q=' + encodeURIComponent(q))
        .then(function (r) { return r.json(); })
        .then(function (j) {
          var f = j.features && j.features[0];
          return f ? { lat: f.geometry.coordinates[1], lon: f.geometry.coordinates[0], cc: (f.properties.countrycode || '').toLowerCase() } : null;
        });
    }
    function lookup(q) {
      var p = 'format=jsonv2&limit=1&addressdetails=1&accept-language=en&q=' + encodeURIComponent(q);
      if (/^\d{5}(-\d{4})?$/.test(q)) p += '&countrycodes=us';   // a bare 5-digit number is a US ZIP code
      return fetch('https://nominatim.openstreetmap.org/search?' + p)
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (j) { return j[0] ? { lat: +j[0].lat, lon: +j[0].lon, cc: (j[0].address || {}).country_code } : null; })
        .catch(function () { return photon(q); });
    }
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var q = input.value.trim();
      if (!q) { status.textContent = 'Type a city, ZIP code, state or country.'; input.focus(); return; }
      if (busy) return;
      busy = true;
      status.textContent = 'Looking up ' + q + '\u2026';
      lookup(q).then(function (g) {
        if (g) return show(g.lat, g.lon, q, g.cc);
        clear();
        status.textContent = 'We couldn\u2019t find \u201c' + q + '\u201d. Try a city and state, a ZIP code or a country.';
      }).catch(function () {
        clear();
        status.textContent = 'We couldn\u2019t look that up just now. Try again in a moment.';
      }).then(function () { busy = false; });
    });
    var me = $('#near-me');
    if (!navigator.geolocation) me.hidden = true;
    me.addEventListener('click', function () {
      status.textContent = 'Finding your location\u2026';
      navigator.geolocation.getCurrentPosition(function (pos) {
        show(pos.coords.latitude, pos.coords.longitude, 'you', null);
      }, function () {
        clear();
        status.textContent = 'We couldn\u2019t get your location. Type a place instead.';
      }, { timeout: 12000, maximumAge: 600000 });
    });
    more.addEventListener('click', function () { draw(true); });
  }

  function watchPage() {
    var big = $('#latest-big');
    if (!big) return;
    var latest = fullFilms().sort(byDate);
    big.innerHTML = filmCard(latest[0], true);
    $('#latest-list').innerHTML = latest.slice(1, 5).map(function (v) { return filmCard(v); }).join('');
    $('#popular').innerHTML = fullFilms().sort(byViews).map(function (v) { return filmCard(v); }).join('');
  }

  function storyPage() {
    var tl = $('#timeline');
    if (!tl) return;
    var S = window.TUCKER_STORY || [];
    tl.innerHTML = S.map(function (e, i) {
      return '<button class="item" type="button" data-story="' + i + '"' + (i === S.length - 1 ? ' style="padding-bottom:0"' : '') + '>' +
        '<span class="year">' + esc(e.year) + '</span><span class="t">' + esc(e.title) + '</span>' +
        '<span class="s">' + esc(e.short) + '</span><span class="more">Read more +</span></button>';
    }).join('');
    $$('#timeline [data-story]').forEach(function (b) { b.addEventListener('click', function () { openStory(+b.getAttribute('data-story')); }); });
    var want = decodeURIComponent(location.hash.slice(1));
    S.forEach(function (e, i) { if (want && e.year.replace(/\s+/g, '-').toLowerCase() === want.toLowerCase()) openStory(i); });
  }

  function pageLink(href) {
    var map = { 'cars.html': URL.cars, 'watch.html': URL.watch, 'story.html': URL.story, 'archive.html': URL.archive, 'shop.html': URL.shop, 'index.html': '/' };
    var base = href.split('#')[0], hash = href.indexOf('#') >= 0 ? href.slice(href.indexOf('#')) : '';
    return (map[base] || href) + hash;
  }
  function openStory(i) {
    var S = window.TUCKER_STORY, e = S[i];
    var imgs = e.images || [];
    var links = (e.links || []).map(function (l) {
      if (l[0] === 'film') return '<a class="btn small" href="' + yt(l[1]) + '" target="_blank" rel="noopener" data-film="' + l[1] + '">▶ ' + esc(l[2]) + '</a>';
      if (l[0] === 'car') return '<a class="btn ghost small" href="' + URL.cars + '#' + l[1] + '">' + esc(l[2]) + '</a>';
      if (l[0] === 'product') return '<a class="btn ghost small" href="/products/' + l[1] + '">' + esc(l[2]) + '</a>';
      return '<a class="btn ghost small" href="' + pageLink(l[1]) + '">' + esc(l[2]) + '</a>';
    }).join('');
    var nav = '<div class="story-nav">' +
      (i > 0 ? '<button type="button" data-go="' + (i - 1) + '">← ' + esc(S[i - 1].year) + '</button>' : '<span></span>') +
      (i < S.length - 1 ? '<button type="button" data-go="' + (i + 1) + '">' + esc(S[i + 1].year) + ' →</button>' : '<span></span>') + '</div>';
    openModal(
      '<button class="icon-btn close" data-x aria-label="Close">' + ICON.close + '</button>' +
      (imgs.length ? '<div class="story-pics">' + imgs.map(function (im) {
        return '<figure><img src="' + file(im[0]) + '" alt="' + esc(im[1]) + '"><figcaption>' + esc(im[1]) + '</figcaption></figure>';
      }).join('') + '</div>' : '') +
      '<div class="story-text"><div class="year">' + esc(e.year) + '</div><h2>' + esc(e.title) + '</h2>' +
        '<p class="lead">' + esc(e.short) + '</p>' + (e.more || []).map(function (m) { return '<p>' + esc(m) + '</p>'; }).join('') +
        (links ? '<div class="story-links">' + links + '</div>' : '') + nav + '</div>', 'story-panel' + (imgs.length ? '' : ' no-pics'));
    $$('#tk-panel [data-go]').forEach(function (b) { b.addEventListener('click', function () { openStory(+b.getAttribute('data-go')); }); });
  }

  function reveal() {
    var els = $$('.tk .reveal');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  function init() {
    if (!$('.tk')) return;
    if (window.TUCKER_CAR && !$('#tk-car-defs')) {
      document.body.insertAdjacentHTML('afterbegin', '<svg id="tk-car-defs" width="0" height="0" style="position:absolute" aria-hidden="true">' + window.TUCKER_CAR.defs + '</svg>');
    }
    document.addEventListener('click', function (e) {
      var f = e.target.closest('[data-film]');
      if (f) { e.preventDefault(); playFilm(f.getAttribute('data-film')); return; }
      var c = e.target.closest('[data-car]');
      if (c) {
        e.preventDefault();
        if (onCarsPage()) openCar(c.getAttribute('data-car'));
        else location.href = URL.cars + '#' + c.getAttribute('data-car');
      }
    });
    window.addEventListener('hashchange', function () {
      var h = decodeURIComponent(location.hash.slice(1));
      if (/^\d{4}$/.test(h) && onCarsPage()) openCar(h);
      else if ($('#timeline')) (window.TUCKER_STORY || []).forEach(function (e, i) { if (e.year.replace(/\s+/g, '-').toLowerCase() === h.toLowerCase()) openStory(i); });
    });
    homeParts();
    carsPage();
    watchPage();
    storyPage();
    $$('.tk [data-mark]').forEach(function (el) { el.innerHTML = mark(el.getAttribute('data-mark'), el.getAttribute('data-class') || ''); });
    reveal();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
